import {
  LoadStatus,
  UploadFileResponse
} from 'src/app/infrastructure/services/models/load.model';
import { MOCK_BASE64 } from './base64.mock';

export const MOCK_FILE_UPLOAD_LOAD_ID = 'LOAD-CME-1710883200000-A1B2C3D4';

export const createMockUploadSuccessResponse = (
  loadId: string
): UploadFileResponse => ({
  loadId,
  status: LoadStatus.COMPLETED,
  statusDescription: 'Carga exitosa',
  totalRows: 0,
  rowsWithErrors: 0,
  errorCount: 0,
  annotatedFileName: null,
  annotatedFileBase64: null,
  hasErrors: false
});

export const createMockUploadValidationFailedResponse = (
  loadId: string
): UploadFileResponse => ({
  loadId,
  status: LoadStatus.VALIDATION_FAILED,
  statusDescription: 'Validacion fallida',
  totalRows: 15,
  rowsWithErrors: 13,
  errorCount: 45,
  annotatedFileName: 'resultado_Prueba de motor 3.csv',
  annotatedFileBase64: MOCK_BASE64,
  hasErrors: true
});
